import { Injectable } from '@angular/core';
import { MenuItem } from '../models/menu-item';
import { NavigationEnd, Router } from '@angular/router';
import { isNull } from 'util';
import { ApiService, LoggerService, User } from 'angular-lib';

@Injectable()
export class MenuService {
    public shortcuts: Array<MenuItem> = [];
    public user: User;

    private savedMenuItem: MenuItem = null;

    constructor(
        private router: Router,
        private apiService: ApiService
    ) {
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .map(_ => this.router.routerState.root)
            .map(route => {
                while (route.firstChild) {
                    route = route.firstChild;
                }

                return route;
            })
            .flatMap(route => route.data)
            .subscribe(data => {
                this.shortcuts = [];
                if (data.menuItems) {
                    for (let menuData of data.menuItems) {
                        if (menuData.type === 'back') {
                            menuData.icon = 'left';
                        }

                        this.shortcuts.push(new MenuItem(menuData));
                    }
                }
            });
    }

    /**
     * Change selected menu
     * @param {MenuItem} item new selected menu
     */
    public selectMenu(item: MenuItem): void {
        LoggerService.info('MENU SELECTED');
        // set to selected menu item
        item.selected = true;
        // if has an action bar, toggle its visibility
        if (this.hasActionBar(item)) {
            if (this.getActionBarVisibility(item) === true) {
               this.setActionBarVisibility(item, false);
            } else {
                this.setActionBarVisibility(item, true);
            }
        }
        // and set other to not selected
        this.shortcuts.forEach(menuItem => {
            if (menuItem !== item) {
                menuItem.selected = false;
                // and hide it action bar if exists
                this.setActionBarVisibility(menuItem, false);
            }
        });
    }

    /**
     * Return provided item's action bar visibility
     * @param {MenuItem} item item to get action bar visibility
     * @returns {boolean} true if the action bar is visible, false otherwise
     */
    public getActionBarVisibility(item: MenuItem): boolean {
        return item.actionBarActive;
    }

    /**
     * Return true if the item has an action bar associated
     * @param {MenuItem} item item to check
     * @returns {boolean} true if this item has an action bar, false otherwise
     */
    public hasActionBar(item: MenuItem): boolean {
        return typeof item.actionComponent !== 'undefined' && !isNull(item.actionComponent);
    }

    /**
     * Change provided item's action bar visibility
     * @param {MenuItem} item item to change visibility
     * @param {boolean} visibility true to display action bar, false otherwise
     */
    public setActionBarVisibility(item: MenuItem, visibility: boolean): void {
        if (this.hasActionBar(item)) {
            item.actionBarActive = visibility;
            LoggerService.info('MENU ACTION VISIBILITY CHANGED => ' + visibility);
        }
    }

    /**
     * Hide currently displayed action bar
     */
    public hideSelectedActionBar(): void {
        this.shortcuts.forEach(menuItem => {
            this.setActionBarVisibility(menuItem, false);
        });
    }

    /**
     * Return currently selected menu item
     * @returns {MenuItem} selected menu item
     */
    public getSelectedItem(): MenuItem {
        let selectedItem = null;
        this.shortcuts.forEach(menuItem => {
            if (menuItem.selected === true) {
                selectedItem = menuItem;
            }
        });
        return selectedItem;
    }

    /**
     * Set provided item's title
     * @param {MenuItem} item item to set a new title
     * @param {string} title new title
     */
    public setTitle(item: MenuItem, title: string): void {
        item.title = title;
    }

    /**
     * Set provided item's icon
     * @param {MenuItem} item item to set a new icon
     * @param {string} icon new icon
     */
    public setIcon(item: MenuItem, icon: string): void {
        item.icon = icon;
    }

    public setUser(userId: number) {
        this.apiService.user(+userId).subscribe(user => {
            this.user = user;
        });
    }

    public backButtonOn(callback: Function) {
        if (this.savedMenuItem === null) {
            this.savedMenuItem = this.shortcuts[0];
            let backMenuItem = new MenuItem({
                type: 'callback',
                icon: 'left'
            });
            backMenuItem.setCallback(() => {
                if (callback()) {
                    let copyMenuItem = Object.assign(Object.create(Object.getPrototypeOf(this.savedMenuItem)), this.savedMenuItem);
                    this.shortcuts[0] = copyMenuItem;
                    this.savedMenuItem = null;
                }
            });
            this.shortcuts[0] = backMenuItem;
        }
    }

    public cancelBackButton() {
        if (this.savedMenuItem !== null && this.shortcuts[0].type !== 'callback') {
            let copyMenuItem = Object.assign(Object.create(Object.getPrototypeOf(this.savedMenuItem)), this.savedMenuItem);
            this.shortcuts[0] = copyMenuItem;
            this.savedMenuItem = null;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/services/menu.service.ts